import { ChangeEvent, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import useSearchUsersPageStyles from './useSearchUsersPageStyles';
import useLayoutStyles from '../../layout/useLayoutStyles';
import { User } from '../../../types';
import useGlobalStyles from '../../useGlobalStyles';
import UserInfo from '../baseComponents/userInfo';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { setHeaderTitle } from '../../../redux/slices/layoutSlice';
import {
  setUserSearchQuery,
  ulistBySearchSelector,
  userSearchQuerySelector,
} from '../../../redux/slices/userSlice';
import GameParrot from '../gameParrot';

const SearchUsersPage = () => {
  const { classes } = useSearchUsersPageStyles();
  const { classes: layoutClasses } = useLayoutStyles();
  const { classes: globalClasses } = useGlobalStyles();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const filteredUsers = useAppSelector(ulistBySearchSelector) || [];
  const userSearchQuery = useAppSelector(userSearchQuerySelector);

  useEffect(() => {
    dispatch(setHeaderTitle('Search Users'));
  }, [dispatch]);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch(setUserSearchQuery(e.target.value));
  };

  /**
   * Handles the user click event.
   * @param username - the username of the user to navigate to.
   */
  const handleUserClick = (username: string) => {
    navigate(`/profile/${username}`);
  };

  return (
    <>
      <div className={layoutClasses.container}>
        <div className={`${classes.header} ${layoutClasses.rightPadding}`}>
          <div className={layoutClasses.boldTitle}>Displaying Users ({filteredUsers.length})</div>
          <input
            id='searchBar'
            placeholder={`👤 Search Users ...`}
            type='text'
            value={userSearchQuery}
            onChange={e => handleInputChange(e)}
            className={`${globalClasses.input} ${classes.searchBar}`}
          />
        </div>
        <div className={classes.searchUsers}>
          {filteredUsers.map((user: User) => (
            <Button
              key={user._id}
              className={classes.searchUserItem}
              onClick={() => handleUserClick(user.username)}>
              <UserInfo
                profilePicture={user.profilePicture}
                username={user.username}
                profilePicSize={60}
              />
            </Button>
          ))}
        </div>
      </div>
      <GameParrot />
    </>
  );
};

export default SearchUsersPage;
